<div class="recovery-page">
  <main class="recovery-card">
    <div class="brand">
      <div class="brand-icon">
        <mat-icon>local_hospital</mat-icon>
      </div>

      <span>Expediente Avicena</span>
    </div>

    @if (!enviado) {
      <div class="illustration">
        <mat-icon>lock_reset</mat-icon>
      </div>

      <h1>¿Olvidaste tu contraseña?</h1>

      <p class="description">
        No te preocupes. Ingresa el correo electrónico asociado a tu cuenta y te enviaremos
        instrucciones para restablecerla.
      </p>

      <form [formGroup]="form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Correo electrónico</mat-label>

          <mat-icon matPrefix>mail_outline</mat-icon>

          <input
            matInput
            type="email"
            formControlName="email"
            autocomplete="email"
            placeholder="nombre@ejemplo.com"
          />

          @if (form.controls.email.hasError('required') && form.controls.email.touched) {
            <mat-error>El correo es obligatorio.</mat-error>
          }

          @if (form.controls.email.hasError('email') && form.controls.email.touched) {
            <mat-error>Ingresa un correo válido.</mat-error>
          }

          @if (form.controls.email.hasError('maxlength')) {
            <mat-error>El correo es demasiado largo.</mat-error>
          }
        </mat-form-field>

        @if (error) {
          <div class="error-message" role="alert">
            <mat-icon>error_outline</mat-icon>
            <span>{{ error }}</span>
          </div>
        }

        <button mat-flat-button class="primary-button" type="submit" [disabled]="cargando" (click)="enviarEmail()">
          @if (cargando) {
            <!-- <mat-icon class="loading-icon">sync</mat-icon> -->
            Enviando solicitud...
          } @else {
            Enviar enlace de recuperación
          }
        </button>
      </form>

      <button mat-button type="button" class="back-button" (click)="volverLogin()">
        <mat-icon>arrow_back</mat-icon>
        Volver al inicio de sesión
      </button>
    } @else {
      <div class="success-icon">
        <mat-icon>mark_email_read</mat-icon>
      </div>

      <h1>Revisa tu correo</h1>

      <p class="description">
        Si existe una cuenta asociada a ese correo, recibirás instrucciones para restablecer tu
        contraseña.
      </p>

      <div class="info-message">
        <mat-icon>info_outline</mat-icon>
        <span>
          Revisa también tu carpeta de correo no deseado. Si no recibes el mensaje, puedes volver a
          intentarlo.
        </span>
      </div>

      <button mat-flat-button class="primary-button" type="button" (click)="volverLogin()">
        Volver al inicio de sesión
      </button>

      <button mat-button class="back-button" type="button" (click)="enviado = false">
        Intentar con otro correo
      </button>
    }

    <p class="footer-text">Expediente Avicena · Gestión de atención médica</p>
  </main>
</div>
